import { PurchaseType } from '@/enums/purchase-type';
import { PurchaseTypeLabels } from '@/enums/purchase-type-labels';
import {
  CustomerReceivable,
  ReceivableCollection,
  ReceivableStatus
} from '@/types/CustomerReceivable.interface';

/** Order of the status filter chips. */
export const RECEIVABLE_STATUSES: ReceivableStatus[] = [
  'OPEN',
  'PARTIAL',
  'PAID',
  'VOID'
];

/** Chip colours: each status is visually distinct. */
export const RECEIVABLE_STATUS_COLOR: Record<
  ReceivableStatus,
  'warning' | 'info' | 'success' | 'default'
> = {
  OPEN: 'warning',
  PARTIAL: 'info',
  PAID: 'success',
  VOID: 'default'
};

/** The admin can void only an untouched, still open receivable. */
export const canVoidReceivable = (
  receivable: Pick<CustomerReceivable, 'status' | 'paidAmount'>
): boolean =>
  receivable.status === 'OPEN' && Number(receivable.paidAmount) === 0;

/** A reversed Cari Tahsilat is an extra negative row pointing at the original. */
export const isReversalCollection = (
  collection: Pick<ReceivableCollection, 'amount' | 'reversesCollectionId'>
): boolean =>
  (collection.reversesCollectionId !== null &&
    collection.reversesCollectionId !== undefined) ||
  Number(collection.amount) < 0;

/**
 * i18n key for a collection tender. The backend sends PurchaseType values
 * (CASH, CARD, MEAL_CARD); the device vocabulary ("meal") is tolerated too.
 * Unknown values come back unchanged so they are still readable.
 */
export const collectionPaymentLabelKey = (paymentType: string): string => {
  const normalized = String(paymentType ?? '').toUpperCase();
  if (normalized === 'MEAL') return PurchaseTypeLabels[PurchaseType.MEAL_CARD];
  if (Object.prototype.hasOwnProperty.call(PurchaseTypeLabels, normalized)) {
    return PurchaseTypeLabels[normalized as PurchaseType];
  }
  return paymentType;
};
